import { format } from 'date-fns';

/**
 * 날짜 표시/변환 유틸.
 * 시각 표시는 `@/utils/date` 의 `formatDate` / `formatDateTime`(브라우저 tz) 사용을 권장합니다.
 * (KST 고정 포맷터 `formatToKST`는 글로벌 서비스 원칙에 따라 제거됨)
 */

/**
 * due date 값을 실제 날짜로 변환합니다
 * @param daysLeft - 남은 일수 (양수) 또는 초과 일수 (음수)
 * @returns 실제 만료 날짜 (YYYY-MM-DD)
 */
const formatDueDateToDate = (daysLeft: number | string | null | undefined): string => {
  if (daysLeft === null || daysLeft === undefined || daysLeft === '') {
    return '-';
  }

  const days = typeof daysLeft === 'string' ? parseInt(daysLeft, 10) : daysLeft;

  if (isNaN(days)) {
    return '-';
  }

  const today = new Date();
  const dueDate = new Date(today.getTime() + days * 24 * 60 * 60 * 1000);

  return format(dueDate, 'yyyy-MM-dd');
};

/**
 * due date 값을 "YYYY-MM-DD (N days left/ago)" 형식으로 변환합니다
 */
export const formatDueDateFull = (
  daysLeft: number | string | null | undefined
): { text: string; isOverdue: boolean } => {
  if (daysLeft === null || daysLeft === undefined || daysLeft === '') {
    return { text: '-', isOverdue: false };
  }

  const days = typeof daysLeft === 'string' ? parseInt(daysLeft, 10) : daysLeft;

  if (isNaN(days)) {
    return { text: '-', isOverdue: false };
  }

  const dateStr = formatDueDateToDate(days);

  if (days === 0) {
    return { text: `${dateStr} (Today)`, isOverdue: false };
  } else if (days > 0) {
    return { text: `${dateStr} (${days} days left)`, isOverdue: false };
  } else {
    return { text: `${dateStr} (${Math.abs(days)} days ago)`, isOverdue: true };
  }
};
